import React from "react";

const styles = {
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
    margin: "10px 0",
  },
  text: {
    fontStyle: "italic",
    color: "#888",
    textAlign: "center",
  },
  svg: {
    width: 24,
    height: 24,
    display: "block",
  },
};

export default function Thinking({ children = "Thinking…" }) {
  return (
    <div style={styles.container} role="status" aria-live="polite">
      <svg style={styles.svg} viewBox="0 0 50 50" aria-hidden="true">
        {/* faint circle background */}
        <circle
          cx="25"
          cy="25"
          r="20"
          fill="none"
          stroke="#eee"
          strokeWidth="4"
        />
        {/* spinning arc */}
        <path
          d="M45 25a20 20 0 0 1-20 20"
          fill="none"
          stroke="#888"
          strokeWidth="4"
          strokeLinecap="round"
        >
          <animateTransform
            attributeName="transform"
            type="rotate"
            from="0 25 25"
            to="360 25 25"
            dur="1s"
            repeatCount="indefinite"
          />
        </path>
      </svg>
      <div style={styles.text}>{children}</div>
    </div>
  );
}
